<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline">
          <span class="font-weight-bold d-flex align-center">
            {{ $t('register') }}
          </span>
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
          <v-form class="py-12 px-2">
            <ValidationProvider v-slot="{ errors, valid }" name="name" rules="required">
              <v-text-field v-model="form.name" outlined dense type="text" :label="$t('your_name')" color="primary" :error-messages="errors" />
            </ValidationProvider>
            <ValidationProvider v-slot="{ errors, valid }" name="email" rules="required|email">
              <v-text-field v-model="form.email" outlined dense type="email" :label="$t('email')" color="primary" :error-messages="errors" />
            </ValidationProvider>
            <ValidationProvider v-slot="{ errors, valid }" name="password" rules="required|min:8">
              <v-text-field v-model="form.password" outlined dense :type="visibility ? 'text' : 'password'" :label="$t('password')" color="primary" :error-messages="errors" :append-icon="visibility ? 'mdi-eye' : 'mdi-eye-off'" autocomplete="on" @click:append="visibility = !visibility" />
            </ValidationProvider>
            <l-a-phone-number v-model="form.phone" :label="$t('fields.phone')" />
            <p class="font-14 soft-grey--text">
              {{ $t('by_registering_you_agree_to_the') }}
              <router-link :to="{ name: 'terms_conditions' }" class="primary--text text-non-direction font-weight-medium">
                {{ $t('terms_of_use') }}
              </router-link>
              {{ $t('and') }}
              <router-link :to="{ name: 'privacy_policy' }" class="primary--text text-non-direction font-weight-medium">
                {{ $t('privacy_policy') }}
              </router-link>.
            </p>
            <v-btn color="primary" x-large block :disabled="disabledRegister" class="text-none" @click="register()">
              {{ $t('register') }}
            </v-btn>
            <div class="mt-5 text-center">
              <router-link :to="{ name: 'forget_password' }" class="grey--text text-non-direction">
                {{ $t('forgot_password') }}
              </router-link>
            </div>
          </v-form>
        </ValidationObserver>
      </v-col>
    </v-row>
    <v-snackbar v-model="dataSuccess.show" multi-line top color="success" :timeout="3000">
      {{ dataSuccess.message }}
      <v-btn class="transparent" text fab x-small dark @click="closeDataSuccess()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import {
  preRegister as preRegisterCustomer
} from '@/api/auth'
import {
  ValidationObserver,
  ValidationProvider
} from 'vee-validate'
import LAPhoneNumber from '@/components/modules/LAphone/Index'
export default {
  components: {
    LAPhoneNumber,
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      dataSuccess: {
        show: false,
        message: ''
      },
      visibility: false,
      password: 'Password',
      form: {
        name: '',
        email: '',
        password: '',
        phone: ''
      },
      form_verification: {},
      disabledRegister: false
    }
  },
  methods: {
    closeDataSuccess() {
      this.dataSuccess.show = false
    },
    async register() {
      this.disabledRegister = true
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        try {
          const { data } = await preRegisterCustomer(this.form)
          data.data.value.id = ''
          this.$store.state.loading_axios = false
          this.dataSuccess.show = true
          this.dataSuccess.message = data.message
          this.$store.dispatch('data_verification', data.data)

          // try {
          //   this.form_verification = {
          //     phone: data.data.phone
          //   }
          //   await sendOtpCustomer(this.form_verification)
          //   this.$store.state.loading_axios = false
          //   this.$store.dispatch('save_type_verification', 'phone')
          //   this.$router.push({ name: 'verification_otp', query: { redirect: this.$route.query.redirect }}).catch(() => {})
          // } catch (e) {
          //   this.$store.state.show_error = true
          //   this.$store.state.error_message = e.string
          //   this.$store.state.error_type = e.statusCode
          // }

          // this.$store.dispatch('save_type_verification', 'phone')
          // this.$router.push({ name: 'verification_otp', query: { redirect: this.$route.query.redirect }}).catch(() => {})

          this.$router.push({ name: 'select_verification', query: { redirect: this.$route.query.redirect }}).catch(() => {})
        } catch (e) {
          if (typeof e.error_tagging !== 'undefined' && e.error_tagging === 'ALREADY_EMAIL' || e.error_tagging === 'ALREADY_PHONE') {
            this.$router.push({ name: 'set_new_password', query: { redirect: this.$route.query.redirect }}).catch(() => {})
          } else {
            this.$store.state.show_error = true
            this.$store.state.error_message = e.string
            this.$store.state.error_type = e.statusCode
          }
        }
      }
      this.disabledRegister = false
    }
  }
}
</script>
